import { Anchor, Breadcrumbs, Card, Grid } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';
import ProfilesForm from './ProfilesForm';

const page = `${Page['profiles']}`;

const ProfilesEditPage = () => {
  const { accountId, domainId, id } = useParams();
  const [profile, setProfile] = useState();
  const [error, setError] = useState();
  const fetch = useFetch();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/profiles/${encodeURIComponent(id)}`)
      .then(({ profile }) => {
        if (profile.registeredAt) {
          profile.registeredAt = new Date(profile.registeredAt);
        }

        if (profile.subscribedAt) {
          profile.subscribedAt = new Date(profile.subscribedAt);
        }

        setProfile(profile);
      })
      .catch(setError);
  }, [accountId, domainId, id, fetch]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (profile === undefined) {
    return <Spinner />;
  }

  let title = `${page}`;
  if (profile && profile.firstName && profile.lastName) {
    title += ` | ${profile.firstName} ${profile.lastName}`;
  }
  title += ' | Edit';

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/profiles` },
    ...(profile && profile.firstName && profile.lastName
      ? [
          {
            title: `${profile.firstName} ${profile.lastName}`,
            href: `#/accounts/${accountId}/domains/${domainId}/profiles/${encodeURIComponent(id)}`,
          },
        ]
      : []),
    { title: 'Edit' },
  ].map((item, index) => (
    <Anchor href={item.href} key={index}>
      {item.title}
    </Anchor>
  ));

  return (
    <>
      <Metadata title={title} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>

      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <ProfilesForm trackingId={id} profileData={profile} />
          </Card>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default ProfilesEditPage;
